import { useState } from "react";

export interface IGeolocationPositionError {
  readonly code: number;
  readonly message: string;
  readonly PERMISSION_DENIED: number;
  readonly POSITION_UNAVAILABLE: number;
  readonly TIMEOUT: number;
}

export type GeoLocationData = {
  loading: boolean;
  latitude: number | null;
  longitude: number | null;
  timestamp: number | null;
  error?: Error | IGeolocationPositionError;
};

type IUseGeoLocation = {
  getLocation: () => void;
  geoLocationData: GeoLocationData;
};
const useGeolocation = (
  options: PositionOptions = {
    enableHighAccuracy: false
  }
): IUseGeoLocation => {
  const [locationData, setLocationState] = useState<GeoLocationData>({
    loading: false,
    latitude: null,
    longitude: null,
    timestamp: null
  });

  const onEvent = (event: {
    coords: { latitude: number; longitude: number };
  }) => {
    setLocationState({
      loading: false,
      latitude: event.coords.latitude,
      longitude: event.coords.longitude,
      timestamp: Date.now()
    });
  };
  const onEventError = (error: IGeolocationPositionError) => {
    setLocationState((oldState) => ({ ...oldState, loading: false, error }));
  };

  const getLocation = async () => {
    if (navigator) {
      setLocationState({
        loading: true,
        latitude: null,
        longitude: null,
        timestamp: null
      });
      await navigator.geolocation.getCurrentPosition(
        onEvent,
        onEventError,
        options
      );
    }
  };

  return {
    getLocation,
    geoLocationData: locationData
  };
};

export { useGeolocation };
